import SegmentQueries from "../data/SegmentQueriesArray.json"
import bibleBookList from "../data/BookChapterList.json"

const bibleBookOrder = Object.keys(bibleBookList)

function findSegment(book, chapter, verse) {
  console.log(`[findSegment] ${book} ${chapter}:${verse}`)
  // console.log(`${typeof book} ${typeof chapter}:${typeof verse}`)
  return SegmentQueries.filter(bookSeg => {
    if (bookSeg.starting_book === book || bookSeg.ending_book === book) {
      // console.log(bookSeg)
      const startingChapter = parseInt(bookSeg.starting_chapter)
      const endingChapter = parseInt(bookSeg.ending_chapter)
      if (chapter >= startingChapter) {
        if (chapter <= endingChapter) {
          // console.log(bookSeg)
          const startingVerse = parseInt(bookSeg.starting_verse)
          const endingVerse = parseInt(bookSeg.ending_verse)
          const diff = endingChapter - startingChapter
          let chapters = []
          if (diff === 0) {
            chapters.push(startingChapter)
          }
          if (diff === 1) {
            chapters.push(startingChapter)
            chapters.push(endingChapter)
          }
          if (diff > 1) {
            for (let i = 0; i <= diff; i++) {
              chapters.push(startingChapter + i)
            }
          }
          const index = chapters.indexOf(chapter)
          if (index === 0) {
            if (verse >= startingVerse) {
              return bookSeg
            }
          } else if (index === chapters.length - 1) {
            if (verse <= endingVerse) {
              return bookSeg
            }
          } else {
            return bookSeg
          }
        }
      }
    }
    return null
  })
}

function getIntro(book) {
  const bookNum = bibleBookOrder.indexOf(book) + 1
  if (bookNum < 10) {
    return `I00${bookNum}`
  } else if (bookNum > 9) {
    return `I0${bookNum}`
  }
}

export default function getSegment(book, chapter, verse) {
  // console.log(`${book} ${chapter}:${verse}`)
  if (+chapter === 0) {
    return getIntro(book)
  } else if (book === "1Sa") {
    if (+chapter >= 31) {
      return "S096"
    } else {
      return findSegment(book, parseInt(chapter), parseInt(verse))[0].segment
    }
  } else if (book === "2Sa") {
    console.log(`${book} ${chapter}: ${verse}`, typeof verse)
    if (chapter === 1) {
      return "S096"
    } else if (chapter === 2) {
      if (verse <= 7) {
        return "S096"
      } else {
        return "S097"
      }
    } else {
      return findSegment(book, parseInt(chapter), parseInt(verse))[0].segment
    }
  } else if (book === "1Ki") {
    if (chapter === 22) {
      if (verse >= 41) {
        return "S115"
      } else {
        return "S114"
      }
    } else {
      return findSegment(book, parseInt(chapter), parseInt(verse))[0].segment
    }
  } else if (book === "2Ki") {
    if (chapter < 4) {
      return "S115"
    } else {
      return findSegment(book, parseInt(chapter), parseInt(verse))[0].segment
    }
  } else {
    return findSegment(book, parseInt(chapter), parseInt(verse))[0].segment
  }
}
